import {InvestigationActionType} from './InvestigationHistory.consts'
import type {InvestigationHistory} from './InvestigationHistory.types'

export const getInvestigationHistoryActionTextByType = (
  investigationHistoryItem: InvestigationHistory,
): string => {
  const assigneeName =
    investigationHistoryItem.assignee?.descriptiveName ??
    investigationHistoryItem.assignee?.userName ??
    'Unknown'
  const comment = investigationHistoryItem.commentText ?? ''
  const commentWithWrapper = comment !== '' ? `: ${comment}` : ''

  switch (investigationHistoryItem.actionType) {
    case InvestigationActionType.TEST_INVESTIGATION_ASSIGN:
    case InvestigationActionType.TEST_INVESTIGATION_ASSIGN_STICKY:
    case InvestigationActionType.BUILD_TYPE_INVESTIGATION_ASSIGN:
    case InvestigationActionType.BUILD_TYPE_INVESTIGATION_ASSIGN_STICKY:
    case InvestigationActionType.BUILD_PROBLEM_INVESTIGATION_ASSIGN:
    case InvestigationActionType.BUILD_PROBLEM_INVESTIGATION_ASSIGN_STICKY:
      return `Failure investigation was assigned to ${assigneeName}${commentWithWrapper}`

    case InvestigationActionType.TEST_INVESTIGATION_REMOVE:
    case InvestigationActionType.TEST_INVESTIGATION_REMOVE_NO_ASSIGNEE:
    case InvestigationActionType.BUILD_TYPE_INVESTIGATION_REMOVE:
    case InvestigationActionType.BUILD_TYPE_INVESTIGATION_REMOVE_NO_ASSIGNEE:
    case InvestigationActionType.BUILD_PROBLEM_INVESTIGATION_REMOVE:
    case InvestigationActionType.BUILD_PROBLEM_INVESTIGATION_REMOVE_NO_ASSIGNEE:
      return `Failure investigation was removed${commentWithWrapper}`

    case InvestigationActionType.TEST_MARK_AS_FIXED:
    case InvestigationActionType.BUILD_TYPE_MARK_AS_FIXED:
    case InvestigationActionType.BUILD_PROBLEM_MARK_AS_FIXED:
      return `Marked as fixed by ${assigneeName}${commentWithWrapper}`

    case InvestigationActionType.TEST_INVESTIGATION_ASSIGN_NO_ASSIGNEE:
    case InvestigationActionType.TEST_INVESTIGATION_ASSIGN_STICKY_NO_ASSIGNEE:
    case InvestigationActionType.BUILD_TYPE_INVESTIGATION_ASSIGN_NO_ASSIGNEE:
    case InvestigationActionType.BUILD_TYPE_INVESTIGATION_ASSIGN_STICKY_NO_ASSIGNEE:
    case InvestigationActionType.BUILD_PROBLEM_INVESTIGATION_ASSIGN_NO_ASSIGNEE:
    case InvestigationActionType.BUILD_PROBLEM_INVESTIGATION_ASSIGN_STICKY_NO_ASSIGNEE:
      return `Failure investigation was assigned${commentWithWrapper}`

    case InvestigationActionType.TEST_MARK_AS_FIXED_NO_ASSIGNEE:
    case InvestigationActionType.BUILD_TYPE_MARK_AS_FIXED_NO_ASSIGNEE:
    case InvestigationActionType.BUILD_PROBLEM_MARK_AS_FIXED_NO_ASSIGNEE:
      return `Marked as fixed${commentWithWrapper}`

    case InvestigationActionType.TEST_INVESTIGATION_CHANGE:
    case InvestigationActionType.BUILD_TYPE_INVESTIGATION_CHANGE:
    case InvestigationActionType.BUILD_PROBLEM_INVESTIGATION_CHANGE:
      return `Investigation was modified${comment != null ? `. ${comment}` : ''}`

    case InvestigationActionType.TEST_INVESTIGATION_CHANGE_WITH_REASSIGN:
    case InvestigationActionType.BUILD_TYPE_INVESTIGATION_CHANGE_WITH_REASSIGN:
    case InvestigationActionType.BUILD_PROBLEM_INVESTIGATION_CHANGE_WITH_REASSIGN:
      return `Investigation was modified and reassigned to ${assigneeName}${
        comment != null ? `. ${comment}` : ''
      }`

    default:
      return `Unknown action type – ${investigationHistoryItem.actionType}`
  }
}
export const getInvestigationHistoryResolveMethod = (
  investigationHistoryItem: InvestigationHistory,
): string | null | undefined => {
  switch (investigationHistoryItem.actionType) {
    case InvestigationActionType.TEST_INVESTIGATION_ASSIGN:
    case InvestigationActionType.TEST_INVESTIGATION_ASSIGN_NO_ASSIGNEE:
    case InvestigationActionType.BUILD_TYPE_INVESTIGATION_ASSIGN:
    case InvestigationActionType.BUILD_TYPE_INVESTIGATION_ASSIGN_NO_ASSIGNEE:
    case InvestigationActionType.BUILD_PROBLEM_INVESTIGATION_ASSIGN:
    case InvestigationActionType.BUILD_PROBLEM_INVESTIGATION_ASSIGN_NO_ASSIGNEE:
      return 'on failure fix'

    case InvestigationActionType.TEST_INVESTIGATION_ASSIGN_STICKY:
    case InvestigationActionType.TEST_INVESTIGATION_ASSIGN_STICKY_NO_ASSIGNEE:
    case InvestigationActionType.BUILD_TYPE_INVESTIGATION_ASSIGN_STICKY:
    case InvestigationActionType.BUILD_TYPE_INVESTIGATION_ASSIGN_STICKY_NO_ASSIGNEE:
    case InvestigationActionType.BUILD_PROBLEM_INVESTIGATION_ASSIGN_STICKY:
    case InvestigationActionType.BUILD_PROBLEM_INVESTIGATION_ASSIGN_STICKY_NO_ASSIGNEE:
      return 'manually'

    default:
      return null
  }
}
